import { render, staticRenderFns } from "./RPStatCardRow.vue?vue&type=template&id=996434c8&"
import script from "./RPStatCardRow.vue?vue&type=script&lang=js&"
export * from "./RPStatCardRow.vue?vue&type=script&lang=js&"
import style0 from "./RPStatCardRow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports